/* file description */

import { assetBaseUrl } from './const';
import { promiseCacher } from '@cui/lcp-tools';
import * as uuid from 'uuid';

// 查询数据资产模型信息
export const getAssetModuleJson = async (
  FetchAPI: any,
  namespaceID: string,
  moduleID: string,
): Promise<any> => {
  const res = await FetchAPI({
    method: 'get',
    url: `${assetBaseUrl}/compose/namespace/${namespaceID}/module/${moduleID}`,
  });
  return res[1]?.data || {};
};

// 查询单挑数据
export const getAssetModuleRecord = async (
  FetchAPI: any,
  namespaceID: string,
  moduleID: string,
  recordID: string,
): Promise<any> => {
  const res = await FetchAPI({
    method: 'get',
    url: `${assetBaseUrl}/compose/namespace/${namespaceID}/module/${moduleID}/record/${recordID}`,
  });
  return res[1]?.data || {};
};

// 数据资产-插入单条记录
export const addOnlyModuleRecord = async (
  FetchAPI: any,
  namespaceID: string,
  moduleID: string,
  data: any,
): Promise<any> => {
  const res = await FetchAPI({
    method: 'post',
    url: `${assetBaseUrl}/compose/namespace/${namespaceID}/module/${moduleID}/record`,
    data,
  });
  return res[1]?.data;
};

// 批量查询模型列表接口
export const getModuleRecordList = async (
  FetchAPI: any,
  namespaceID: string,
  moduleID: string,
  data: any,
): Promise<any> => {
  // TODO 暂时忽略请求，未排查到哪里触发
  if (!namespaceID || !moduleID) {
    return {
      set: [],
    };
  }
  const res = await FetchAPI({
    method: 'post',
    url: `${assetBaseUrl}/compose/listRecords/namespace/${namespaceID}/module/${moduleID}`,
    data,
  });
  const result = res[1]?.data;
  if (!result?.set) {
    result.set = [];
  }
  return res[1]?.data;
};

export const getModuleRecordListCache = promiseCacher(getModuleRecordList);

// 数据资产-更新记录
export const editModuleRecordList = async (
  FetchAPI: any,
  namespaceID: string,
  moduleID: string,
  recordID: string,
  data: any,
): Promise<any> => {
  const res = await FetchAPI({
    method: 'post',
    url: `${assetBaseUrl}/compose/namespace/${namespaceID}/module/${moduleID}/record/${recordID}`,
    data,
  });
  return res[1]?.data;
};

// 数据资产-删除记录
export const delModuleRecordList = async (
  FetchAPI: any,
  namespaceID: string,
  moduleID: string,
  recordID: string,
): Promise<any> => {
  const res = await FetchAPI({
    method: 'delete',
    url: `${assetBaseUrl}/compose/namespace/${namespaceID}/module/${moduleID}/record/${recordID}`,
  });
  return res[1]?.data;
};

// 查询上传临时签名
export const getPolicy = async (
  FetchAPI: any,
  fileName: string,
): Promise<any> => {
  const res = await FetchAPI({
    method: 'get',
    url: `${assetBaseUrl}/file/getPolicy/${fileName}`,
  });
  return res[1]?.data;
};

// 上传
export const policyUpload = async (
  FetchAPI: any,
  url: string,
  data: any,
): Promise<any> => {
  const res = await FetchAPI({
    method: 'post',
    url,
    data,
  });
  return res;
};

export const upload = async (FetchAPI: any, file: any): Promise<any> => {
  const formData = new FormData();
  formData.append('file', file.file);
  const folder = `lcp/${uuid.v4()}`;
  formData.append('folder', folder);
  const res = await FetchAPI({
    method: 'post',
    url: `${assetBaseUrl}/file/upload`,
    data: formData,
    timeout: 3600000,
  });
  return res[1]?.data;
};

// 编码自动生成 接口文档 http://api-dev.xuelei.com/gateway/metabase/doc.html#/default/%E5%87%BD%E6%95%B0%E6%95%B0%E6%8D%AE%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/queryUsingGET
export const getAutoCode = async (
  FetchAPI: any,
  parameters: any,
  funcName?: string,
): Promise<any> => {
  const res = await FetchAPI({
    method: 'post',
    url: `${assetBaseUrl}/func/v1/query_func_data`,
    data: {
      funcName,
      parameters,
    },
  });
  return res;
};

// 获取用户中心角色
export const getAllRole = async (FetchAPI: any, data?: any): Promise<any> => {
  const res = await FetchAPI({
    method: 'get',
    url: '/api/gateway/system/role/list',
    data,
  });
  return res[1]?.data;
};

export const getAllRoleCache = promiseCacher(getAllRole);

// 根据角色获取用户
export const getUserByRole = async (
  FetchAPI: any,
  data?: any,
): Promise<any> => {
  const res = await FetchAPI({
    method: 'post',
    url: '/api/gateway/system/role/users',
    data,
  });
  return res[1]?.data;
};

// 获取全部用户
export const getAllUser = async (FetchAPI: any): Promise<any> => {
  const res = await FetchAPI({
    method: 'get',
    url: '/api/gateway/system/user/list',
  });
  return res[1]?.data;
};

// 获取组织树
export const getDepTree = async (FetchAPI: any): Promise<any> => {
  const res = await FetchAPI({
    method: 'get',
    url: '/api/gateway/system/user/v2/dptree',
  });
  return res[1]?.data;
};

export const getApiData = async (
  FetchAPI: any,
  url: string,
  data: any,
): Promise<any> => {
  const res = await FetchAPI({
    method: 'post',
    url,
    data,
  });
  return res[1]?.data;
};

// 数据资产-批量更新
export const batchUpdate = async (FetchAPI: any, data: any): Promise<any> => {
  const res = await FetchAPI({
    method: 'post',
    url: `${assetBaseUrl}/api/v1/${data.namespaceID}/${data.moduleID}/multiple_update`,
    data: data.parameterList,
  });
  return res[1]?.data;
};

// 数据资产-批量新增
export const batchCreate = async (FetchAPI: any, data: any): Promise<any> => {
  const res = await FetchAPI({
    method: 'post',
    url: `${assetBaseUrl}/api/v1/${data.namespaceID}/${data.moduleID}/create_batch`,
    data: data.parameterList,
  });
  return res[1]?.data;
};

// 数据资产-删除
export const deleteAssetRecord = async (
  FetchAPI: any,
  data: any,
): Promise<any> => {
  const res = await FetchAPI({
    method: 'delete',
    url: `${assetBaseUrl}/api/v1/${data.namespaceID}/${data.moduleID}/delete/${data.id}`,
  });
  return res[1]?.data;
};

export const getOpenApiData = async (
  FetchAPI: any,
  type: string,
  url: string,
  data?: any,
): Promise<any> => {
  if (type === 'get') {
    const res = await FetchAPI({
      method: type,
      url,
      params: data,
    });
    return res[1]?.data;
  } else {
    const res = await FetchAPI({
      method: type,
      url,
      data,
    });
    return res[1]?.data;
  }
};

export const getOpenApiDataCache = promiseCacher(getOpenApiData);

// 获取当前数据页数
export const getDataPosition = async (
  FetchAPI: any,
  data?: any,
): Promise<any> => {
  const res = await FetchAPI({
    method: 'post',
    url: '/api/gateway/metabase/serviceFlow/api/common_data_position',
    data,
  });
  return res[1]?.data;
};

// 根据页面配置下载数据(redis)
export const readyDownload = async (
  FetchAPI: any,
  data?: any,
): Promise<any> => {
  const res = await FetchAPI({
    method: 'post',
    url: `/api/gateway/workspaceservice/workspace/batch/import/page/general/downloadData/${data.taskId}`,
    data,
  });
  return res[1]?.data;
};

// 获取数据下载结果
export const getDownLoad = async (FetchAPI: any, data?: any): Promise<any> => {
  const res = await FetchAPI({
    method: 'post',
    url: `/api/gateway/workspaceservice/workspace/batch/import/page/get/downloadResult/${data.taskId}`,
  });
  return res[1]?.data;
};

// 查询树形数据
export const getTreeData = async (FetchAPI: any, data?: any): Promise<any> => {
  const res = await FetchAPI({
    method: 'post',
    url: `/api/gateway/metabase/api/v1/${data.namespaceID}/${data.moduleID}/query_tree_data`,
    data,
  });
  return res[1]?.data;
};
